import LibraryAgent from "./LibraryAgent";

export default function Agent() {
    return (
        <div>
            <LibraryAgent />
        </div>
    );
}